<template>
  <div id="numpad-overlay" :style="{display : displayMode}">
    <div class="overlay" @click="emitAndHide()"></div>
    <div id="numpad">
      <div type="text" class="new-order" style="width: 90%">
        <input ref="numberInput" autocomplete="off" type="text" v-model="entered"/>
      </div>
      <div class="d-flex">
        <div class="key" @click="entered += 1">
          <div>1</div>
        </div>
        <div class="key" @click="entered += 2">
          <div>2</div>
        </div>
        <div class="key" @click="entered += 3">
          <div>3</div>
        </div>
      </div>
      <div class="d-flex">
        <div class="key" @click="entered += 4">
          <div>4</div>
        </div>
        <div class="key" @click="entered += 5">
          <div>5</div>
        </div>
        <div class="key" @click="entered += 6">
          <div>6</div>
        </div>
      </div>
      <div class="d-flex">
        <div class="key" @click="entered += 7">
          <div>7</div>
        </div>
        <div class="key" @click="entered += 8">
          <div>8</div>
        </div>
        <div class="key" @click="entered += 9">
          <div>9</div>
        </div>
      </div>
      <div class="d-flex">
        <div class="key" @click="removeAll()">
          <div>X</div>
        </div>
        <div class="key" @click="entered += 0">
          <div>0</div>
        </div>
        <div class="key" @click="removeLast()">
          <div><--</div>
        </div>
      </div>
      <div class="d-flex">
        <div class="key ok" @click="emitAndHide()">
          <div>Ok</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Numpad',
  data() {
    return {
      displayMode: 'none',
      entered: '',
    };
  },
  updated() {
    this.$refs.numberInput.focus();
  },
  methods: {
    show() {
      this.displayMode = 'flex';
    },
    emitAndHide() {
      this.$emit('get-text', this.entered);
      this.displayMode = 'none';
    },
    removeAll() {
      this.entered = '';
    },
    removeLast() {
      this.entered = this.entered.slice(0, -1);
    },
  },
};
</script>

<style scoped>
  #numpad-overlay {
    justify-content: center;
    align-items: center;
  }

  #numpad {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    background: #FFF;
    overflow: hidden;
    overflow: auto;
    z-index: 2000;
    /*position: absolute;*/
    border: 1px solid #ccc;
    width: 228;
    padding: 10px;
    background: whitesmoke;
  }

  div {
    cursor: pointer;
  }

  .close {
    margin: 5;
    width: 120px;
    height: 48px;
  }

  .clear {
    margin: 5;
    width: 120px;
    height: 48px;
  }

  .key {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px;
    width: 60px;
    height: 55px;
    background: #E5E5E5;
    border: 1px solid #7E8A97;
    border-radius: 4px;
  }

  .ok {
    margin: 5;
    width: 90px;
    height: 48px;
    color: #F00;
  }

  .overlay {
    background: #E5E5E5;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    opacity: .65;
  }
</style>



// WEBPACK FOOTER //
// src/components/Numpad.vue